PJQ.collections.meetings = {};

PJQ.models.meetings = {};

PJQ.views.meetings = {};

PJQ.modules.meetings = {
    routes: [
        {
            route: 'projects/:projectId/meetings',
            name: 'meetings',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "meetings");
            }
        },
        {
            route: 'projects/:projectId/meetings/:meetingId',
            name: 'meeting',
            callback: function (projectId, meetingId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "meetings", {
                    meetingId: parseInt(meetingId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.meetings.routes);
